import {useContext} from "react";
import {AppContext} from "~/context/AppProvider";
export default function useGroup() {
	const { groups } = useContext(AppContext);
	return groups;
}